import React, { useState } from 'react';
import { Download, Smartphone, CheckCircle, Sparkles, Video, TrendingUp } from 'lucide-react';

export default function DownloadPage() {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = () => {
    setDownloading(true);
    
    // ✅ UTILISE LE CHEMIN ABSOLU VERS LE PUBLIC
    const apkUrl = `${window.location.origin}/TeckiA_Mobile.apk`;
    
    // Ouvre dans un nouvel onglet pour forcer le téléchargement
    window.open(apkUrl, '_blank');
    
    // Reset après 2 secondes
    setTimeout(() => setDownloading(false), 2000);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-slate-950 flex items-center justify-center p-6">
      <div className="max-w-2xl w-full">
        {/* LOGO */}
        <div className="text-center mb-8">
          <div className="inline-block bg-gradient-to-r from-purple-600 to-pink-600 p-4 rounded-3xl mb-6">
            <h1 className="text-lg md:text-3xl font-bold text-white flex items-center gap-3">
              <img 
                src="/Teckia-smil.png" 
                alt="TeckiA IA" 
                className="w-24 h-24 rounded-full object-cover"
              />
              Télécharger TeckiA Android
            </h1>
          </div>
        </div>

        {/* VERSION BADGE */}
        <div className="text-center mb-8">
          <div className="text-center text-purple-400 text-sm mb-4">
            <h3 className="text-white font-semibold flex items-center gap-2 justify-center">
              Vous trouverez ci-dessous le lien pour Télécharger l'application TeckiA afin de booster votre business et profiter de la puissance de l'IA
            </h3>
          </div>
          <span className="inline-flex items-center gap-2 bg-purple-500/20 text-purple-300 px-6 py-3 rounded-full text-sm font-semibold border border-purple-500/30">
            <Sparkles size={16} />
            Application garantie sécurisé !
          </span>
        </div>

        {/* BOUTON DOWNLOAD */}
        <div className="bg-white/5 backdrop-blur-xl rounded-3xl p-8 border border-white/10 shadow-2xl mb-8">
          <button
            onClick={handleDownload}
            disabled={downloading}
            className="w-full bg-gradient-to-r from-purple-600 via-pink-600 to-cyan-500 hover:from-purple-700 hover:via-pink-700 hover:to-cyan-600 text-white font-bold py-6 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3 text-lg"
          >
            {downloading ? (
              <>
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white"></div>
                Téléchargement...
              </>
            ) : (
              <>
                <Download size={24} />
                Télécharger l'APK
              </>
            )}
          </button>

          {/* INSTRUCTIONS */}
          <div className="mt-8 bg-purple-500/10 rounded-2xl p-6 border border-purple-500/20">
            <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
              <CheckCircle size={20} className="text-green-400" />
              Instructions d'installation
            </h3>
            
            <ol className="space-y-3 text-purple-200">
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center text-white text-sm font-bold">1</span>
                <span>Téléchargez le fichier APK</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center text-white text-sm font-bold">2</span>
                <span>Ouvrez le fichier téléchargé</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center text-white text-sm font-bold">3</span>
                <span>Autorisez l'installation depuis "Sources inconnues"</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center text-white text-sm font-bold">4</span>
                <span>Suivez les instructions à l'écran</span>
              </li>
            </ol>
          </div>
        </div>

        {/* FEATURES */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10">
            <div className="w-12 h-12 bg-purple-500/20 rounded-xl flex items-center justify-center mb-4">
              <Sparkles size={24} className="text-purple-400" />
            </div>
            <h3 className="text-white font-semibold mb-2">Marketing et Essayage Virtuel</h3>
            <p className="text-purple-300 text-sm">Fashion AI Technology</p>
          </div>

          <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10">
            <div className="w-12 h-12 bg-pink-500/20 rounded-xl flex items-center justify-center mb-4">
              <Video size={24} className="text-pink-400" />
            </div>
            <h3 className="text-white font-semibold mb-2">Génération vidéos</h3>
            <p className="text-purple-300 text-sm">TeckiA AI V12 & V15</p>
          </div>

          <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-6 border border-white/10">
            <div className="w-12 h-12 bg-cyan-500/20 rounded-xl flex items-center justify-center mb-4">
              <TrendingUp size={24} className="text-cyan-400" />
            </div>
            <h3 className="text-white font-semibold mb-2">ChatBot Intégré & Réseaux sociaux</h3>
            <p className="text-purple-300 text-sm">Toujours disponible 24/7</p>
          </div>
        </div>

        {/* FOOTER */}
        <div className="text-center text-purple-400 text-sm">
          © 2025 TDI Digital • TeckiA<br/>
          Tous droits réservés
        </div>
      </div>
    </div>
  );
}